var _defs, _sodipodiNamedview;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnsLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 674.92047,
    height: 224.32736,
    viewBox: "0 0 674.92047 224.32736",
    sodipodiDocname: "Sun-and-Soul-Blue-Logo-Pdf_04042022.ai",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("colorProfile", {
    inkscapeLabel: "Coated FOGRA39 (ISO 12647-2:2004)",
    name: "Coated-FOGRA39-ISO-12647-2:2004",
    id: "color-profile1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-141.0324,-393.80211)",
    id: "path2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-117.0777,-448.08771)",
    id: "path4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-101.9122,-408.96761)",
    id: "path6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-156.1978,-432.92231)",
    id: "path8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-158.55,-417.74621)",
    id: "path10"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-99.560005,-424.14361)",
    id: "path12"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-125.8563,-391.44991)",
    id: "path14"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-132.25371,-450.44001)",
    id: "path16"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-152.9991,-403.42721)",
    id: "path18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-105.11091,-438.46261)",
    id: "path20"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-111.5373,-397.00081)",
    id: "path22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-146.57271,-444.88901)",
    id: "path24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath26"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-139.7017,-400.92121)",
    id: "path26"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-118.40841,-440.96871)",
    id: "path28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-109.03131,-410.29821)",
    id: "path30"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-149.0787,-431.59161)",
    id: "path32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-151.7194,-420.15331)",
    id: "path34"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-106.3906,-421.73651)",
    id: "path36"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-128.26341,-398.28051)",
    id: "path38"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-129.8466,-443.60931)",
    id: "path40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-148.2871,-408.92721)",
    id: "path42"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-109.8229,-432.96261)",
    id: "path44"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-117.0373,-401.71281)",
    id: "path46"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-141.0727,-440.17711)",
    id: "path48"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-251.0893,-432.57231)",
    id: "path50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath52"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-327.22711,-427.65581)",
    id: "path52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-373.42601,-470.11091)",
    id: "path54"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-271.49881,-358.29821)",
    id: "path56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-290.07361,-372.41801)",
    id: "path58"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-329.15551,-402.90371)",
    id: "path60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-425.19211,-369.13571)",
    id: "path62"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath64"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-488.05721,-374.06721)",
    id: "path64"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath66"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,841.89 H 595.276 V 0 H 0 Z",
    transform: "translate(-517.23862,-357.41931)",
    id: "path66"
  })))), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview1",
    pagecolor: "#ffffff",
    bordercolor: "#000000",
    borderopacity: 0.25,
    inkscapeShowpageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer-MC0",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "Layer 1",
    transform: "translate(-59.909665,-449.09647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m 0,0 c 5.138,-0.812 9.986,-1.678 14.862,-2.329 14.383,-1.922 28.209,1.065 41.947,4.852 1.732,0.478 3.656,0.946 5.367,0.665 C 65.128,2.702 67.2,0.92 67.2,-2.428 67.2,-5.523 64.887,-7.823 61.528,-8.248 43.062,-11.674 17.801,-10.091 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,188.0432,597.45053)",
    clipPath: "url(#clipPath2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "m 0,0 c -5.138,0.812 -9.986,1.678 -14.862,2.329 -14.383,1.922 -28.209,-1.065 -41.947,-4.852 -1.732,-0.478 -3.656,-0.946 -5.367,-0.665 -2.952,0.486 -5.024,2.268 -5.024,5.616 0,3.095 2.313,5.395 5.672,5.82 C -43.062,11.674 -17.801,10.091 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,156.1036,525.06973)",
    clipPath: "url(#clipPath4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 0,0 c -0.812,-5.138 -1.678,-9.986 -2.329,-14.862 -1.922,-14.383 1.065,-28.209 4.852,-41.947 0.478,-1.732 0.946,-3.656 0.665,-5.367 -0.486,-2.952 -2.268,-5.024 -5.616,-5.024 -3.095,0 -5.395,2.313 -5.82,5.672 C -11.674,-43.062 -10.091,-17.801 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,135.88293,577.22987)",
    clipPath: "url(#clipPath6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 0,0 c 0.812,5.138 1.678,9.986 2.329,14.862 1.922,14.383 -1.065,28.209 -4.853,41.947 -0.477,1.732 -0.945,3.656 -0.664,5.367 0.486,2.952 2.268,5.024 5.616,5.024 3.095,0 5.395,-2.313 5.82,-5.672 C 11.674,43.062 10.091,17.801 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,208.26373,545.29027)",
    clipPath: "url(#clipPath8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 0,0 c 3.272,4.044 6.446,7.809 9.448,11.706 8.856,11.495 13.182,24.963 16.771,38.754 0.453,1.739 1.009,3.639 2.109,4.98 1.896,2.314 4.475,3.217 7.375,1.543 2.68,-1.548 3.516,-4.701 2.204,-7.822 C 31.641,31.456 17.64,10.37 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,211.4,565.52507)",
    clipPath: "url(#clipPath10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 0,0 c -3.272,-4.044 -6.446,-7.809 -9.448,-11.706 -8.856,-11.495 -13.182,-24.963 -16.771,-38.754 -0.453,-1.739 -1.009,-3.639 -2.109,-4.98 -1.896,-2.314 -4.475,-3.217 -7.375,-1.543 -2.68,1.548 -3.516,4.701 -2.204,7.822 C -31.641,-31.456 -17.64,-10.37 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,132.74667,556.9952)",
    clipPath: "url(#clipPath12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "m 0,0 c 4.044,-3.272 7.809,-6.446 11.706,-9.448 11.495,-8.856 24.963,-13.182 38.754,-16.771 1.739,-0.453 3.639,-1.009 4.98,-2.109 2.314,-1.896 3.217,-4.475 1.543,-7.375 -1.548,-2.68 -4.701,-3.516 -7.822,-2.204 C 31.456,-31.641 10.37,-17.64 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,167.8084,600.5868)",
    clipPath: "url(#clipPath14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 0,0 c -4.044,3.272 -7.809,6.446 -11.706,9.448 -11.495,8.856 -24.963,13.182 -38.754,16.771 -1.739,0.453 -3.639,1.009 -4.98,2.109 -2.314,1.896 -3.217,4.475 -1.543,7.375 1.548,2.68 4.701,3.516 7.822,2.204 C -31.456,31.641 -10.37,17.64 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,176.33827,521.93333)",
    clipPath: "url(#clipPath16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "m 0,0 c 4.856,1.866 9.487,3.54 14.035,5.414 13.417,5.527 23.898,15.027 33.901,25.176 1.262,1.28 2.694,2.647 4.316,3.259 2.799,1.055 5.485,0.548 7.159,-2.352 1.547,-2.68 0.694,-5.829 -2.002,-7.876 C 43.13,11.421 20.461,0.161 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,203.9988,584.61707)",
    clipPath: "url(#clipPath18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "m 0,0 c -4.856,-1.866 -9.487,-3.54 -14.035,-5.414 -13.417,-5.527 -23.898,-15.027 -33.901,-25.176 -1.262,-1.28 -2.694,-2.647 -4.316,-3.259 -2.799,-1.055 -5.485,-0.548 -7.159,2.352 -1.547,2.68 -0.694,5.829 2.002,7.876 C -43.13,-11.421 -20.461,-0.161 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,140.14787,537.9032)",
    clipPath: "url(#clipPath20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "m 0,0 c 1.866,-4.856 3.54,-9.487 5.414,-14.035 5.527,-13.417 15.027,-23.898 25.176,-33.901 1.28,-1.262 2.647,-2.694 3.259,-4.316 1.055,-2.799 0.548,-5.485 -2.352,-7.159 -2.68,-1.547 -5.829,-0.694 -7.876,2.002 C 11.421,-43.13 0.161,-20.461 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,148.7164,593.1856)",
    clipPath: "url(#clipPath22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "m 0,0 c -1.866,4.856 -3.54,9.487 -5.414,14.035 -5.527,13.417 -15.027,23.898 -25.176,33.901 -1.28,1.262 -2.647,2.694 -3.259,4.316 -1.055,2.799 -0.548,5.485 2.352,7.159 2.68,1.547 5.829,0.694 7.876,-2.002 C -11.421,43.13 -0.161,20.461 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,195.43027,529.33467)",
    clipPath: "url(#clipPath24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "m 0,0 c 3.963,-0.332 7.706,-0.721 11.46,-0.946 11.072,-0.662 21.446,2.388 31.708,6.042 1.294,0.461 2.734,0.925 4.054,0.806 C 49.5,5.697 51.179,4.454 51.366,1.901 51.538,-0.458 49.904,-2.341 47.367,-2.852 33.48,-6.495 14.134,-6.699 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,186.26893,587.9584)",
    clipPath: "url(#clipPath26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "m 0,0 c -3.963,0.332 -7.706,0.721 -11.46,0.946 -11.072,0.662 -21.446,-2.388 -31.708,-6.042 -1.294,-0.461 -2.734,-0.925 -4.054,-0.806 -2.278,0.205 -3.957,1.448 -4.144,4.001 -0.172,2.359 1.462,4.242 3.999,4.753 C -33.48,6.495 -14.134,6.699 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,157.87787,534.56173)",
    clipPath: "url(#clipPath28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path29",
    d: "m 0,0 c -0.332,-3.963 -0.721,-7.706 -0.946,-11.46 -0.662,-11.072 2.388,-21.446 6.042,-31.708 0.461,-1.294 0.925,-2.734 0.806,-4.054 -0.205,-2.278 -1.448,-3.957 -4.001,-4.144 -2.359,-0.172 -4.242,1.462 -4.753,3.999 C -6.495,-33.48 -6.699,-14.134 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,145.37507,575.45573)",
    clipPath: "url(#clipPath30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "m 0,0 c 0.332,3.963 0.721,7.706 0.946,11.46 0.662,11.072 -2.388,21.446 -6.042,31.708 -0.461,1.294 -0.925,2.734 -0.806,4.054 0.205,2.278 1.448,3.957 4.001,4.144 2.359,0.172 4.242,-1.462 4.753,-3.999 C 6.495,33.48 6.699,14.134 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,198.7716,547.06453)",
    clipPath: "url(#clipPath32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path33",
    d: "m 0,0 c 2.269,3.266 4.478,6.313 6.549,9.452 6.11,9.258 8.656,19.766 10.622,30.48 0.248,1.351 0.566,2.831 1.329,3.915 1.316,1.87 3.232,2.703 5.536,1.588 2.13,-1.03 2.943,-3.387 2.118,-5.84 C 22.365,25.747 12.869,8.891 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,202.29253,562.3156)",
    clipPath: "url(#clipPath34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "m 0,0 c -2.269,-3.266 -4.478,-6.313 -6.549,-9.452 -6.11,-9.258 -8.656,-19.766 -10.622,-30.48 -0.248,-1.351 -0.566,-2.831 -1.329,-3.915 -1.316,-1.87 -3.232,-2.703 -5.536,-1.588 -2.13,1.03 -2.943,3.387 -2.118,5.84 C -22.365,-25.747 -12.869,-8.891 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,141.85413,560.20467)",
    clipPath: "url(#clipPath36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path37",
    d: "m 0,0 c 3.266,-2.269 6.313,-4.478 9.452,-6.549 9.258,-6.11 19.766,-8.656 30.48,-10.622 1.351,-0.248 2.831,-0.566 3.915,-1.329 1.87,-1.316 2.703,-3.232 1.588,-5.536 -1.031,-2.13 -3.387,-2.943 -5.84,-2.118 C 25.747,-22.365 8.891,-12.869 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,171.01787,591.47933)",
    clipPath: "url(#clipPath38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "m 0,0 c -3.266,2.269 -6.313,4.478 -9.452,6.549 -9.258,6.11 -19.766,8.656 -30.48,10.622 -1.351,0.248 -2.831,0.566 -3.915,1.329 -1.87,1.316 -2.703,3.232 -1.588,5.536 1.03,2.13 3.387,2.943 5.84,2.118 C -25.747,22.365 -8.891,12.869 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,173.1288,531.04093)",
    clipPath: "url(#clipPath40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path41",
    d: "m 0,0 c 3.598,1.694 7.035,3.228 10.397,4.911 9.92,4.963 17.38,12.791 24.439,21.086 0.891,1.046 1.906,2.168 3.109,2.725 2.075,0.961 4.151,0.725 5.589,-1.392 1.329,-1.958 0.855,-4.405 -1.087,-6.116 C 32.243,11.115 15.59,1.265 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,197.71613,577.28373)",
    clipPath: "url(#clipPath42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "m 0,0 c -3.598,-1.694 -7.035,-3.228 -10.397,-4.911 -9.92,-4.963 -17.38,-12.791 -24.439,-21.086 -0.891,-1.046 -1.906,-2.168 -3.109,-2.725 -2.075,-0.961 -4.151,-0.725 -5.589,1.392 -1.329,1.958 -0.855,4.405 1.087,6.116 C -32.242,-11.115 -15.59,-1.265 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,146.43053,545.23653)",
    clipPath: "url(#clipPath44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path45",
    d: "m 0,0 c 1.694,-3.598 3.228,-7.035 4.911,-10.397 4.963,-9.92 12.791,-17.38 21.086,-24.439 1.046,-0.891 2.168,-1.906 2.725,-3.109 0.961,-2.075 0.725,-4.151 -1.392,-5.589 -1.958,-1.329 -4.405,-0.855 -6.116,1.087 C 11.115,-32.242 1.265,-15.59 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,156.04973,586.90293)",
    clipPath: "url(#clipPath46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "m 0,0 c -1.694,3.598 -3.228,7.035 -4.911,10.397 -4.963,9.92 -12.791,17.38 -21.086,24.439 -1.046,0.891 -2.168,1.906 -2.725,3.109 -0.961,2.075 -0.725,4.151 1.392,5.589 1.958,1.329 4.405,0.855 6.116,-1.087 C -11.115,32.242 -1.265,15.59 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,188.09693,535.6172)",
    clipPath: "url(#clipPath48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path49",
    d: "M 0,0 C 2.204,-1.604 4.736,-2.854 7.524,-3.716 10.3,-4.574 13.24,-5.01 16.26,-5.01 c 6.136,0 11.603,1.683 16.268,5.016 2.329,1.712 4.14,3.754 5.381,6.067 1.261,2.344 1.9,4.852 1.9,7.454 0,3.041 -0.908,5.918 -2.699,8.553 -1.736,2.553 -4.185,4.734 -7.292,6.492 -1.246,0.692 -2.766,1.282 -4.519,1.754 -1.685,0.453 -3.448,0.813 -5.313,1.078 l -3.209,0.459 c -2.419,0.302 -4.433,0.595 -5.985,0.867 -1.405,0.249 -2.692,0.649 -3.793,1.174 -1.83,0.914 -3.382,2.208 -4.616,3.848 -1.177,1.559 -1.748,3.049 -1.748,4.554 0,1.209 0.336,2.36 1.027,3.519 0.733,1.228 1.809,2.364 3.238,3.408 1.412,1.088 3.122,1.933 5.083,2.512 4.008,1.187 8.537,1.191 12.503,0.001 1.941,-0.581 3.679,-1.434 5.145,-2.519 1.342,-1.022 2.379,-2.146 3.081,-3.345 0.679,-1.155 1.033,-2.32 1.084,-3.562 l 0.128,-3.119 7.904,4.414 -0.232,1.339 c -0.702,4.066 -3.072,7.656 -7.089,10.704 -4.647,3.317 -10.113,4.999 -16.247,4.999 -3.02,0 -5.959,-0.435 -8.737,-1.293 -2.791,-0.865 -5.322,-2.115 -7.531,-3.722 -2.314,-1.702 -4.132,-3.699 -5.403,-5.934 -1.308,-2.292 -1.971,-4.782 -1.971,-7.402 0,-3.241 0.994,-6.285 2.953,-9.046 1.909,-2.698 4.557,-4.888 7.879,-6.514 2.082,-1.008 4.588,-1.751 7.447,-2.209 2.714,-0.438 4.289,-0.688 4.768,-0.754 6.234,-0.733 9.043,-1.659 10.263,-2.287 1.902,-1.034 3.389,-2.281 4.419,-3.709 0.974,-1.347 1.448,-2.74 1.448,-4.26 0,-2.656 -1.354,-4.944 -4.148,-7.002 C 24.596,4.252 20.765,3.099 16.26,3.099 14.045,3.099 11.92,3.4 9.942,3.994 8.009,4.573 6.313,5.418 4.901,6.506 L 4.815,6.568 C 2.152,8.396 0.784,10.645 0.632,13.446 L 0.465,16.515 -7.43,12.109 -7.161,10.741 C -6.323,6.499 -3.917,2.887 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,334.78573,545.75693)",
    clipPath: "url(#clipPath50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path51",
    d: "m 0,0 c 3.407,0 6.662,0.662 9.674,1.969 3.001,1.3 5.707,3.176 8.003,5.537 2.347,2.281 4.167,5.002 5.408,8.086 1.232,3.062 1.857,6.332 1.857,9.72 V 64.83 H 16.926 V 25.312 c 0,-2.335 -0.436,-4.59 -1.297,-6.701 -0.858,-2.104 -2.075,-3.952 -3.617,-5.494 -1.611,-1.609 -3.466,-2.86 -5.513,-3.719 -4.027,-1.689 -8.767,-1.735 -12.905,0 -2.048,0.858 -3.903,2.109 -5.512,3.719 -1.545,1.543 -2.762,3.391 -3.619,5.495 -0.859,2.105 -1.295,4.359 -1.295,6.7 V 64.83 h -8.017 V 25.312 c 0,-3.388 0.625,-6.658 1.857,-9.718 1.238,-3.086 3.058,-5.807 5.37,-8.05 2.333,-2.4 5.056,-4.277 8.092,-5.578 C -6.486,0.662 -3.28,0 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,436.3028,552.31227)",
    clipPath: "url(#clipPath52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path53",
    d: "M 0,0 41.775,-42.361 V 22.375 H 33.759 V -19.623 L -8.017,22.646 V -41.805 H 0 Z",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,497.90133,495.70547)",
    clipPath: "url(#clipPath54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path55",
    d: "m 0,0 c -1.747,-0.952 -3.467,-1.436 -5.116,-1.436 -2.502,0 -4.83,0.475 -6.92,1.412 -2.044,0.913 -3.668,2.151 -4.827,3.678 -1.111,1.464 -1.651,3.028 -1.651,4.782 0,2.413 0.645,4.255 1.971,5.63 1.313,1.362 3.389,2.744 6.182,4.117 L 4.526,2.899 C 2.949,1.754 1.433,0.783 0,0 m 7.202,11.83 c -7.825,7.882 -13.91,14.062 -18.109,18.388 -0.909,0.907 -1.797,2.16 -2.636,3.725 -0.773,1.443 -1.164,3.044 -1.166,4.682 0.103,2.645 1.023,4.727 2.815,6.367 1.941,1.784 4.219,2.65 6.964,2.65 2.807,0 5.116,-0.867 7.041,-2.634 0.855,-0.806 1.533,-1.78 2.013,-2.893 C 4.606,41.002 4.85,39.852 4.85,38.7 4.85,37.652 4.374,36.498 3.434,35.271 2.37,33.88 0.837,32.551 -1.123,31.319 l -2.069,-1.301 6.054,-5.875 1.301,0.922 c 1.588,1.124 3.027,2.363 4.272,3.676 2.939,3.08 4.43,6.431 4.43,9.959 0,2.293 -0.46,4.518 -1.366,6.61 -0.9,2.08 -2.202,3.945 -3.868,5.544 -1.666,1.595 -3.615,2.826 -5.797,3.657 -4.327,1.647 -9.227,1.645 -13.489,-0.004 -2.144,-0.829 -4.076,-2.059 -5.742,-3.654 -1.666,-1.598 -2.968,-3.463 -3.866,-5.54 -0.902,-2.076 -1.392,-4.282 -1.459,-6.613 0,-3.154 0.686,-6.022 2.04,-8.527 1.273,-2.347 2.748,-4.374 4.384,-6.027 -2.826,-1.614 -5.108,-3.428 -6.802,-5.413 -2.274,-2.666 -3.428,-6.13 -3.428,-10.297 0,-3.3 0.991,-6.388 2.944,-9.177 1.917,-2.739 4.541,-4.919 7.798,-6.479 3.216,-1.541 6.806,-2.323 10.67,-2.323 2.978,0 5.852,0.751 8.541,2.234 2.113,1.165 4.399,2.671 6.815,4.486 l 6.239,-6.071 H 27.683 L 24.474,-5.63 C 20.945,-2.041 15.189,3.781 7.202,11.83",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,361.9984,644.78907)",
    clipPath: "url(#clipPath56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path57",
    d: "m 0,0 -3.484,-2.751 5.879,-5.7 7.484,6.262 -5.697,5.695 z",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,386.7648,625.96267)",
    clipPath: "url(#clipPath58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path59",
    d: "m 0,0 c 1.414,1.089 3.124,1.933 5.084,2.511 4.009,1.188 8.541,1.191 12.503,0.002 1.94,-0.581 3.678,-1.434 5.146,-2.52 1.342,-1.02 2.378,-2.145 3.08,-3.346 0.678,-1.151 1.033,-2.317 1.085,-3.561 l 0.129,-3.118 7.901,4.414 -0.231,1.34 C 33.994,-0.214 31.625,3.376 27.608,6.425 22.961,9.742 17.494,11.424 11.361,11.424 8.34,11.424 5.4,10.989 2.624,10.13 -0.168,9.265 -2.699,8.015 -4.908,6.408 -7.222,4.706 -9.04,2.709 -10.311,0.475 c -1.307,-2.293 -1.969,-4.783 -1.969,-7.401 0,-3.243 0.994,-6.288 2.952,-9.047 1.908,-2.697 4.556,-4.887 7.878,-6.513 2.082,-1.009 4.589,-1.753 7.448,-2.21 2.713,-0.437 4.288,-0.688 4.768,-0.754 6.234,-0.733 9.042,-1.659 10.262,-2.286 1.902,-1.034 3.389,-2.281 4.421,-3.709 0.973,-1.348 1.447,-2.741 1.447,-4.261 0,-2.655 -1.354,-4.943 -4.148,-7.002 -3.05,-2.273 -6.882,-3.426 -11.387,-3.426 -2.215,0 -4.34,0.301 -6.318,0.894 -1.937,0.581 -3.633,1.426 -5.041,2.513 l -0.087,0.063 c -2.661,1.825 -4.029,4.075 -4.183,6.878 l -0.168,3.068 -7.892,-4.406 0.269,-1.367 c 0.835,-4.241 3.241,-7.854 7.16,-10.742 2.205,-1.605 4.736,-2.855 7.524,-3.717 2.775,-0.858 5.715,-1.293 8.736,-1.293 6.136,0 11.603,1.682 16.269,5.015 2.329,1.713 4.139,3.755 5.38,6.068 1.261,2.345 1.901,4.852 1.901,7.454 0,3.041 -0.909,5.918 -2.7,8.553 -1.737,2.553 -4.185,4.735 -7.292,6.492 -1.242,0.69 -2.763,1.281 -4.52,1.755 -1.69,0.453 -3.453,0.812 -5.239,1.066 l -3.282,0.47 c -2.428,0.304 -4.442,0.596 -5.986,0.867 -1.403,0.248 -2.689,0.648 -3.792,1.174 -1.828,0.913 -3.381,2.207 -4.617,3.848 -1.176,1.559 -1.748,3.049 -1.748,4.555 0,1.207 0.336,2.359 1.027,3.518 C -2.505,-2.18 -1.429,-1.044 0,0",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,438.874,585.31507)",
    clipPath: "url(#clipPath60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path61",
    d: "m 0,0 c -2.175,-3.747 -5.162,-6.764 -8.881,-8.966 -3.703,-2.195 -7.809,-3.307 -12.204,-3.307 -4.396,0 -8.502,1.112 -12.205,3.307 -3.721,2.203 -6.726,5.222 -8.931,8.975 -2.197,3.735 -3.31,7.89 -3.31,12.349 0,4.459 1.113,8.614 3.31,12.35 2.207,3.755 5.211,6.774 8.931,8.976 3.706,2.194 7.812,3.306 12.205,3.306 4.392,0 8.498,-1.112 12.204,-3.306 3.717,-2.201 6.705,-5.219 8.88,-8.966 2.169,-3.741 3.269,-7.9 3.269,-12.36 C 3.268,7.897 2.168,3.74 0,0 m -4.798,40.706 c -4.982,2.915 -10.461,4.392 -16.287,4.392 -5.828,0 -11.307,-1.477 -16.287,-4.393 -4.974,-2.913 -8.955,-6.928 -11.833,-11.932 -2.881,-5.006 -4.341,-10.527 -4.341,-16.415 0,-5.886 1.46,-11.408 4.34,-16.412 2.878,-5.005 6.859,-9.02 11.834,-11.933 4.978,-2.915 10.457,-4.394 16.287,-4.394 5.828,0 11.307,1.478 16.288,4.394 4.973,2.913 8.955,6.928 11.833,11.933 2.881,5.006 4.342,10.529 4.342,16.412 0,5.885 -1.461,11.407 -4.342,16.414 -2.879,5.005 -6.861,9.02 -11.834,11.934",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,566.9228,630.33907)",
    clipPath: "url(#clipPath62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path63",
    d: "m 0,0 c 0,-2.337 -0.436,-4.592 -1.296,-6.702 -0.859,-2.104 -2.075,-3.953 -3.618,-5.494 -1.609,-1.609 -3.464,-2.861 -5.513,-3.719 -4.025,-1.688 -8.763,-1.736 -12.905,0 -2.049,0.858 -3.903,2.109 -5.511,3.72 -1.546,1.544 -2.763,3.392 -3.619,5.493 -0.86,2.106 -1.296,4.361 -1.296,6.702 v 39.518 h -8.016 V 0 c 0,-3.388 0.624,-6.658 1.856,-9.721 1.241,-3.086 3.062,-5.807 5.37,-8.047 2.334,-2.401 5.057,-4.278 8.094,-5.579 3.044,-1.304 6.249,-1.965 9.529,-1.965 3.407,0 6.662,0.662 9.674,1.968 3.003,1.301 5.708,3.177 8.002,5.537 2.346,2.278 4.166,4.998 5.409,8.086 C 7.392,-6.66 8.017,-3.389 8.017,0 V 39.518 H 0 Z",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,650.74293,623.76373)",
    clipPath: "url(#clipPath64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path65",
    d: "m 0,0 v 56.165 h -8.016 v -64.18 h 41.9 V 0 Z",
    style: {
      fill: "#1c9ec6",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.3333333,0,0,-1.3333333,689.65147,645.96093)",
    clipPath: "url(#clipPath66)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnsLogoBlue);
export default __webpack_public_path__ + "static/media/SNS_Logo_Blue.798116d8dfda49c0e4b6a6515b05858f.svg";
export { ForwardRef as ReactComponent };